import React from 'react';
import PropTypes from 'prop-types';
import ShapeSwatchPicker from './ShapeSwatchPicker.jsx';

class ShapesTab extends React.Component {
  render() {
    const {
      style, patchStyle, moduleShapes, eyeFrameShapes, eyeBallShapes, swatches,
    } = this.props;
    return (
      <div className="qr-shapes-tab">
        <div className="qr-field">
          <label className="qr-label">Body dots</label>
          <ShapeSwatchPicker options={moduleShapes} swatches={swatches.module_shape} value={style.module_shape} onChange={(v) => patchStyle('module_shape', v)} />
        </div>
        <div className="qr-field">
          <label className="qr-label">Eye frame</label>
          <ShapeSwatchPicker options={eyeFrameShapes} swatches={swatches.eye_frame_shape} value={style.eye_frame_shape} onChange={(v) => patchStyle('eye_frame_shape', v)} />
        </div>
        <div className="qr-field qr-field--last">
          <label className="qr-label">Eye ball</label>
          <ShapeSwatchPicker options={eyeBallShapes} swatches={swatches.eye_ball_shape} value={style.eye_ball_shape} onChange={(v) => patchStyle('eye_ball_shape', v)} />
        </div>
      </div>
    );
  }
}

ShapesTab.propTypes = {
  style: PropTypes.object.isRequired,
  patchStyle: PropTypes.func.isRequired,
  moduleShapes: PropTypes.arrayOf(PropTypes.string).isRequired,
  eyeFrameShapes: PropTypes.arrayOf(PropTypes.string).isRequired,
  eyeBallShapes: PropTypes.arrayOf(PropTypes.string).isRequired,
  swatches: PropTypes.object.isRequired,
};

export default ShapesTab;
